import Layout from '@/views/layout/index'

// noCache 不缓存
// hidden 不在左侧菜单栏显示
const eaRouter = [
  {
    path: '/redirects',
    component: Layout,
    name: 'redirects',
    redirect: '/redirects/redirectsindex',
    hidden: true,
    meta: {
      title: '跳转页',
      noCache: true,
    },
    children: [
      {
        path: 'redirectsindex',
        component: () => import('@/views/redirect/index'),
        name: 'redirectsindex',
        meta: {
          title: '跳转页子叶',
          noCache: true,
        },
      }
    ]
  },
  {
    path: '/',
    name: 'home',
    component: Layout,
    redirect: '/homeIndex',
    meta: {
      title: '首页',
      icon: 'icon-home'
    },
    children: [{
      path: 'homeIndex',
      component: () => import ('@/views/home/homeIndex'),
      name: 'homeIndex',
      meta: { title: '首页', icon: 'icon-home' },
    }]
  },
  {
    path: '/deviceManage',
    name: 'deviceManage',
    redirect: '/deviceManage/disk_pack',
    component: Layout,
    meta: {
      title: '税控管理',
      icon: 'icon-kitchen'
    },
    children: [{
      path: 'disk_pack',
      component: () => import ('@/views/deviceManage/disk_pack'),
      name: 'disk_pack',
      meta: { title: '盘组设备管理', icon: 'fapiao' },
    },{
      path: 'tax_control_panel',
      component: () => import ('@/views/deviceManage/tax_control_panel'),
      name: 'tax_control_panel',
      meta: { title: '税控盘管理', icon: 'fapiao' },
    },
    {
      path: 'tax_control_panel_status',
      component: () => import ('@/views/deviceManage/tax_control_panel_status'),
      name: 'tax_control_panel_status',
      meta: { title: '税控盘状态', icon: 'fapiao' },
    },
    {
      path: 'admin',
      component: () => import ('@/views/deviceManage/admin'),
      name: 'admin',
      meta: { title: '管理员', icon: 'fapiao', power: 'admin' },
    }
    // {
    //   path: 'disk_password',
    //   component: () => import ('@/views/deviceManage/disk_password'),
    //   name: 'disk_password',
    //   meta: { title: '盘口令设置', icon: 'fapiao' },
    // },
   ]
  },
  // {
  //   path: '/invoiceManage',
  //   name: 'index',
  //   redirect: '/index/index1',
  //   component: Layout,
  //   meta: {
  //     title: '开票管理',
  //     icon: 'icon-creditcard'
  //   },
  //   children: [{
  //     path: 'invoicing',
  //     component: () => import ('@/views/index/invoicing'),
  //     name: 'invoicing',
  //     meta: { title: '发票开具', icon: 'fapiao' },
  //   },{
  //     path: 'invoiceQuery',
  //     component: () => import ('@/views/index/invoiceQuery'),
  //     name: 'invoiceQuery',
  //     meta: { title: '发票查询', icon: 'fapiao' },
  //   },{
  //     path: 'queryPrint',
  //     component: () => import ('@/views/index/queryPrint'),
  //     name: 'queryPrint',
  //     meta: { title: '发票打印', icon: 'fapiao' },
  //   },
  //   // {
  //   //   path: 'index6',
  //   //   component: () => import ('@/views/index/index6'),
  //   //   name: 'index6',
  //   //   meta: { title: '发票修复', icon: 'fapiao' },
  //   // },
  //   // {
  //   //   path: 'index6',
  //   //   component: () => import ('@/views/index/index7'),
  //   //   name: 'index6',
  //   //   meta: { title: '未上传发票查询', icon: 'fapiao' },
  //   // },
  //   {
  //     path: 'applyInvoiceInfo',
  //     component: () => import ('@/views/index/applyInvoiceInfo'),
  //     name: 'applyInvoiceInfo',
  //     meta: { title: '红字信息表', icon: 'fapiao' },
  //   },{
  //     path: 'statistics',
  //     component: () => import ('@/views/index/statistics'),
  //     name: 'statistics',
  //     meta: { title: '资料统计', icon: 'fapiao' },
  //   },]
  // },
  // {
  //   path: '/setting',
  //   name: 'setting',
  //   redirect: '/setting/admin',
  //   component: Layout,
  //   meta: {
  //     title: '参数设置',
  //     icon: 'icon-set'
  //   },
  //   children: [
    // {
    //   path: 'goods',
    //   component: () => import ('@/views/setting/goods'),
    //   name: 'goods',
    //   meta: { title: '商品管理', icon: 'fapiao' },
    // },{
    //   path: 'buyerSeller',
    //   component: () => import ('@/views/setting/buyerSeller'),
    //   name: 'buyerSeller',
    //   meta: { title: '购销方信息管理', icon: 'fapiao' },
    // },
    // {
    //   path: 'print',
    //   component: () => import ('@/views/setting/print'),
    //   name: 'print',
    //   hidden: true,
    //   meta: { title: '打印机设置', icon: 'fapiao' },
    // },{
    //   path: 'settings',
    //   component: () => import ('@/views/setting/settings'),
    //   name: 'settings',
    //   meta: { title: '设置', icon: 'fapiao' },
    // },
    // {
    //   path: 'admin',
    //   component: () => import ('@/views/setting/admin'),
    //   name: 'admin',
    //   meta: { title: '管理员', icon: 'fapiao', power: 'admin' },
    // }]
  // },
  // {
  //   path: '/apply',
  //   name: 'apply',
  //   redirect: '/apply/InvoiceInventory',
  //   component: Layout,
  //   meta: {
  //     title: '发票管理',
  //     icon: 'icon-kitchen'
  //   },
  //   children: [{
  //     path: 'InvoiceInventory',
  //     component: () => import ('@/views/apply/InvoiceInventory'),
  //     name: 'InvoiceInventory',
  //     meta: { title: '余票查询', icon: 'fapiao' },
  //   },
  //   {
  //     path: 'InvoiceApply',
  //     component: () => import ('@/views/apply/InvoiceApply'),
  //     name: 'InvoiceApply',
  //     hidden: true,
  //     meta: { title: '发票领购', icon: 'fapiao' },
  //   },
  //   {
  //     path: 'InvoiceApplyStatus',
  //     component: () => import ('@/views/apply/InvoiceApplyStatus'),
  //     name: 'InvoiceApplyStatus',
  //     hidden: true,
  //     meta: { title: '发票领购状态', icon: 'fapiao' },
  //   },
  //   {
  //     path: 'InvoiceApplyList',
  //     component: () => import ('@/views/apply/InvoiceApplyList'),
  //     name: 'InvoiceApplyList',
  //     meta: { title: '发票分发', icon: 'fapiao' },
  //   },]
  // },

  // {
  //   path: '/taxManage',
  //   name: 'taxManage',
  //   redirect: '/taxManage/copy_tax',
  //   component: Layout,
  //   meta: {
  //     title: '税控管理',
  //     icon: 'icon-kitchen'
  //   },
  //   children: [{
  //     path: 'copy_tax',
  //     component: () => import ('@/views/index/copy_tax'),
  //     name: 'copy_tax',
  //     meta: { title: '抄税反写', icon: 'fapiao' },
  //   },{
  //     path: 'company',
  //     component: () => import ('@/views/taxManage/company'),
  //     name: 'company',
  //     meta: { title: '设备管理', icon: 'fapiao' },
  //   },]
  // },
  
]

export default eaRouter